import { render, staticRenderFns } from "./PresentPost.vue?vue&type=template&id=38516777&"
import script from "./PresentPost.vue?vue&type=script&lang=js&"
export * from "./PresentPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports